import RemoteAction from './remote-action';
import RemoteActionError from './custom-errors';

const getGUID = () => {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }

    return `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
};

const decodeHtml = (html) => {
    if (!html) return html;

    const txt = window.document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
};

class Enumeration {
    constructor(name, ordinal, value) {
        this.name = name;
        this.ordinal = ordinal;

        if (typeof value === 'object') {
            this.freeze.call(this, value);
        }
    }

    freeze(obj) {
        if (typeof obj !== 'object') {
            return;
        }

        Object.keys(obj).forEach((key) => {
            this[key] = obj[key];

            if (typeof obj[key] === 'object') {
                this.freeze.call(this[key], this[key]);
            }
        });

        Object.freeze(this);
    }

    toString() {
        return this.name;
    }

    equals(value) {
        if (typeof value === 'object' && value.name) {
            value = value.name;
        }

        if (typeof value === 'string') {
            return this.name === value;
        }

        return false;
    }

    equalsByOrdinal(value) {
        if (typeof value !== 'number') {
            return false;
        }

        return this.ordinal === value;
    }
}

class Enumerator {
    constructor(value) {
        if (Array.isArray(value)) {
            value.forEach((key, index) => {
                this[key] = new Enumeration(key, index);
            });
        } else if (typeof value === 'object') {
            Object.keys(value).forEach((key, index) => {
                this[key] = new Enumeration(key, index, value[key]);
            });
        }

        return Object.freeze(this);
    }
}

const genericRemoteActionInvocation = (action, args = [], config = {}) => {
    if (!action) throw new Error('Missing required param: action');
    if (!args || !Array.isArray(args)) throw new Error('Missing or invalid param: args');

    const defaults = {
        escape: false,
        buffer: false,
        timeout: 30000
    };

    return new Promise((resolve, reject) => {
        new RemoteAction()
            .setAction(action)
            .setErrorHandler((response, event) => reject(new RemoteActionError(event)))
            .invoke(args, response => resolve(response), { ...defaults, ...config });
    });
};

const getURLParams = () => {
    const params = {};

    window.location.href.replace(/[?&]+([^=&]+)=?([^&]*)/gi, (m, key, value) => {
        params[key] = value;
    });

    return params;
};

export {
    getGUID,
    decodeHtml,
    Enumerator,
    Enumeration,
    genericRemoteActionInvocation,
    getURLParams
};
